import posthog from "posthog-js";
import { getCurrencyFromSearchParams } from "./currency";
import { getEnvs } from "./env";
import { getWhiteLabel } from "./white-label";

const { VERCEL_ENV, MOZIO_PUBLIC_POSTHOG_KEY, MOZIO_PUBLIC_POSTHOG_HOST } =
  getEnvs();

const PRODUCT_NAME = "Parking";

export const setPostHog = () => {
  const refParam = new URLSearchParams(window.location.search).get("ref");

  if (refParam === "aws-synthetics-canaries") {
    return;
  }

  if (!MOZIO_PUBLIC_POSTHOG_KEY || !MOZIO_PUBLIC_POSTHOG_HOST) {
    console.error(
      "Posthog integration is not configured properly so it will not be loaded.",
    );
    return;
  }

  const { id, name } = getWhiteLabel();

  posthog.init(MOZIO_PUBLIC_POSTHOG_KEY, {
    api_host: MOZIO_PUBLIC_POSTHOG_HOST,
    debug: VERCEL_ENV === "development",
    loaded: (posthog) => {
      posthog.register({
        product: PRODUCT_NAME,
        app_version: APP_VERSION,
        white_label_name: name,
        white_label_id: id,
        displayed_currency: getCurrencyFromSearchParams(),
        //TODO: this field should be moved to header once we accept multiple languages
        displayed_locale: "en_US",
      });
    },
  });
};
